/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedResultDto_CommisionListDto } from '../models/PagedResultDto_CommisionListDto';
import type { Wealthlane_AwardService_Dtos_Commission_AddCommisionRateScheduleDto } from '../models/Wealthlane_AwardService_Dtos_Commission_AddCommisionRateScheduleDto';
import type { Wealthlane_AwardService_Dtos_Commission_CommisionNameListDto } from '../models/Wealthlane_AwardService_Dtos_Commission_CommisionNameListDto';
import type { Wealthlane_AwardService_Dtos_Commission_UpdateCommisionRateScheduleDto } from '../models/Wealthlane_AwardService_Dtos_Commission_UpdateCommisionRateScheduleDto';
import type { Wealthlane_Shared_Hosting_Dtos_GenericApiResponse } from '../models/Wealthlane_Shared_Hosting_Dtos_GenericApiResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class CommissionService {

    /**
     * @param requestBody
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericApiResponse OK
     * @throws ApiError
     */
    public static postApiAwardApiAppCommissionCommissionRateSchedule(
        requestBody?: Wealthlane_AwardService_Dtos_Commission_AddCommisionRateScheduleDto,
    ): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericApiResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/commission/commission-rate-schedule',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericApiResponse OK
     * @throws ApiError
     */
    public static putApiAwardApiAppCommissionCommissionRateSchedule(
        requestBody?: Wealthlane_AwardService_Dtos_Commission_UpdateCommisionRateScheduleDto,
    ): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericApiResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/award/api/app/commission/commission-rate-schedule',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param filter
     * @param sorting
     * @param skipCount
     * @param maxResultCount
     * @returns PagedResultDto_CommisionListDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppCommissionCommissionList(
        filter?: string,
        sorting?: string,
        skipCount?: number,
        maxResultCount?: number,
    ): CancelablePromise<PagedResultDto_CommisionListDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/commission/commission-list',
            query: {
                'Filter': filter,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id
     * @returns Wealthlane_AwardService_Dtos_Commission_UpdateCommisionRateScheduleDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppCommissionCommissionById(
        id: string,
    ): CancelablePromise<Wealthlane_AwardService_Dtos_Commission_UpdateCommisionRateScheduleDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/commission/{id}/commission-by-id',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericApiResponse OK
     * @throws ApiError
     */
    public static deleteApiAwardApiAppCommissionCommission(
        id: string,
    ): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericApiResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/award/api/app/commission/{id}/commission',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param brokerId
     * @returns Wealthlane_AwardService_Dtos_Commission_CommisionNameListDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppCommissionCommissionsByBrokerIdAnync(
        brokerId: string,
    ): CancelablePromise<Array<Wealthlane_AwardService_Dtos_Commission_CommisionNameListDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/commission/commissions-by-broker-id-anync/{brokerId}',
            path: {
                'brokerId': brokerId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
